// extracted by mini-css-extract-plugin
module.exports = {"info":"LoginInfo_info__pg7Eb","popover":"LoginInfo_popover__B10QS"};